import React from "react";
import ContactCard from "./ContactCard/ContactCard.component";

const Contacts = ({ contacts, onContactSelected }) =>
  contacts.map((contact, index) => (
    <ContactCard key={index} contact={contact} onClick={onContactSelected} />
  ));

export default Contacts;
